import { useEffect, useState } from "react";
import "@/App.css";
import { Phone, MapPin, Clock, Globe, Menu, X, ArrowRight, Sparkles, ZoomIn } from "lucide-react";

const IMG = {
  hero: "https://customer-assets.emergentagent.com/job_2cdd1a56-a627-4860-b59f-66e396c91def/artifacts/j46488l0_671F43CB-465B-4BEB-8E46-2F8396AA3C02.PNG",
  gallery1: "https://customer-assets.emergentagent.com/job_2cdd1a56-a627-4860-b59f-66e396c91def/artifacts/wvtupo0k_3B31C4B3-3710-408C-98AD-C05D53C77129.JPEG",
  gallery2: "https://customer-assets.emergentagent.com/job_2cdd1a56-a627-4860-b59f-66e396c91def/artifacts/xwa3gay0_733333D1-152C-4454-B0CE-17860C8AE6E7.PNG",
  gallery3: "https://customer-assets.emergentagent.com/job_2cdd1a56-a627-4860-b59f-66e396c91def/artifacts/2dnsbe00_EC7D0B69-9142-4E06-9F2D-DCBD818F5C90.JPEG",
  gallery4: "https://customer-assets.emergentagent.com/job_2cdd1a56-a627-4860-b59f-66e396c91def/artifacts/j46488l0_671F43CB-465B-4BEB-8E46-2F8396AA3C02.PNG",
  parking: "https://customer-assets-cm19k8pv.emergentagent.net/job_fusion-grid-view/artifacts/suehny4u_C77A5289-CE91-48A0-AA93-0418CED2A652.JPEG",
  koreanBBQ: "https://customer-assets-cm19k8pv.emergentagent.net/job_fusion-grid-view/artifacts/r4eu4bu6_%D0%A2%D0%B5%D0%BC%D0%B0%202.png",
  hotPot: "https://customer-assets-cm19k8pv.emergentagent.net/job_fusion-grid-view/artifacts/q6qu9jx8_%D0%A2%D0%B5%D0%BC%D0%B0%203.png",
};

const NAV_LINKS = [
  { label: "Über uns", href: "#about" },
  { label: "Galerie", href: "#gallery" },
  { label: "Öffnungszeiten", href: "#hours" },
  { label: "Menü", href: "#menu" },
  { label: "Kontakt", href: "#contact" },
  { label: "Parkplatz", href: "#parking" },
];

const HOURS = [
  { day: "Montag", time: "11:00 – 15:00  ·  16:30 – 22:00" },
  { day: "Dienstag", time: "Geschlossen", closed: true },
  { day: "Mittwoch", time: "11:00 – 15:00  ·  16:30 – 22:00" },
  { day: "Donnerstag", time: "11:00 – 15:00  ·  16:30 – 22:00", today: true },
  { day: "Freitag", time: "11:00 – 15:00  ·  16:30 – 22:00" },
  { day: "Samstag", time: "11:30 – 15:30  ·  16:30 – 22:00" },
  { day: "Sonntag", time: "11:30 – 15:30  ·  16:30 – 22:00" },
];

const ALA_CARTE = [
  ["01", "Gebratener Reis mit frischem Gemüse", "€ 10,80"],
  ["02", "Verschiedenes Gemüse mit Reis", "€ 10,80"],
  ["03", "Gebratene Nudeln mit Hühnerfleisch und Gemüse", "€ 10,80"],
  ["04", "Gebratene Nudeln mit Garnelen und Gemüse", "€ 12,80"],
  ["05", "Chop Suey mit Hühnerfleisch und Reis", "€ 12,80"],
  ["06", "Tofu mit Gemüse und Reis", "€ 10,80"],
  ["07", "Hühnerfleisch mit Gemüse, Chili und Reis", "€ 13,50"],
  ["08", "Chop Suey mit Rindfleisch und Reis", "€ 13,50"],
  ["09", "Rindfleisch mit Gemüse, Chili und Reis", "€ 13,90"],
  ["10", "Teriyaki Huhn mit Gemüse und Reis", "€ 13,90"],
  ["11", "Gebratene Reisnudeln mit Hühnerfleisch und Gemüse", "€ 12,80"],
  ["12", "Ente mit Gemüse und Reis", "€ 15,20"],
  ["13", "Garnelen mit Gemüse in scharfer Soße und Reis", "€ 15,20"],
  ["14", "Garnelen mit Gemüse in Currysoße und Reis", "€ 15,20"],
];

const TAKEAWAY = [
  { name: "Box 1", price: "3,90 €", desc: "Gebratene Nudeln oder Reis mit Gemüse" },
  { name: "Box 2", price: "5,50 €", desc: "Gebratene Nudeln oder Reis mit knusprigem Huhn" },
  { name: "Box 3", price: "7,00 €", desc: "Gebratene Nudeln oder Reis mit Ente" },
  { name: "Box 4", price: "5,80 €", desc: "Gebratene Nudeln oder Reis mit gebratenem Hühnerfleisch" },
  { name: "Box 5", price: "6,20 €", desc: "Gebratene Nudeln oder Reis mit Rindfleisch und Zwiebeln" },
  { name: "Frühlingsrollen", price: "3,00 €", desc: "10 Stück mit Süß-Sauer-Sauce" },
];

const BUFFETS = [
  {
    title: "Mittagsbuffet",
    time: "11:00 – 15:00 Uhr · Mo, Mi, Do, Fr",
    twoColumns: true,
    columns: [
      {
        label: "Ohne Getränke",
        prices: [
          ["Kinder 3–5 Jahre", "5,80 €"],
          ["Kinder 6–9 Jahre", "8,80 €"],
          ["Kinder 10–12 Jahre", "11,80 €"],
          ["Erwachsene", "13,80 €"],
        ],
      },
      {
        label: "Mit Getränken",
        prices: [
          ["Kinder 3–5 Jahre", "7,80 €"],
          ["Kinder 6–9 Jahre", "9,80 €"],
          ["Kinder 10–12 Jahre", "12,80 €"],
          ["Erwachsene", "15,80 €"],
        ],
      },
    ],
    note: "Inkl. 2 Getränke · Bier · Wein · Softdrinks. Weitere Getränke +1,50 €. Mittagsbuffetdauer 2:30 Std., danach je 30 Min. +2 €.",
  },
  {
    title: "Mittagsbuffet",
    time: "11:30 – 15:30 Uhr · Sa, So & Feiertage",
    twoColumns: true,
    columns: [
      {
        label: "Ohne Getränke",
        prices: [
          ["Kinder 3–5 Jahre", "8,80 €"],
          ["Kinder 6–9 Jahre", "14,80 €"],
          ["Kinder 10–12 Jahre", "18,80 €"],
          ["Erwachsene", "21,80 €"],
        ],
      },
      {
        label: "Mit Getränken",
        prices: [
          ["Kinder 3–5 Jahre", "10,80 €"],
          ["Kinder 6–9 Jahre", "16,80 €"],
          ["Kinder 10–12 Jahre", "21,80 €"],
          ["Erwachsene", "24,80 €"],
        ],
      },
    ],
    note: "Inkl. 2 Getränke · Bier · Wein · Softdrinks. Weitere Getränke +1,50 €. Mittagsbuffetdauer 2:30 Std., danach je 30 Min. +2 €.",
  },
  {
    title: "Abendbuffet",
    time: "16:30 – 22:00 Uhr · Mo, Mi, Do, Fr, Sa, So & Feiertage",
    twoColumns: true,
    columns: [
      {
        label: "Ohne Getränke",
        prices: [
          ["Kinder 3–5 Jahre", "10,80 €"],
          ["Kinder 6–9 Jahre", "17,80 €"],
          ["Kinder 10–12 Jahre", "22,80 €"],
          ["Erwachsene", "25,80 €"],
        ],
      },
      {
        label: "Mit Getränken",
        prices: [
          ["Kinder 3–5 Jahre", "12,80 €"],
          ["Kinder 6–9 Jahre", "19,80 €"],
          ["Kinder 10–12 Jahre", "25,80 €"],
          ["Erwachsene", "28,80 €"],
        ],
      },
    ],
    note: "Inkl. 3 Getränke · Bier · Wein · Softdrinks. Weitere Getränke +1,50 €. Abendbuffetdauer 2:30 Std., danach je 30 Min. +2 €.",
    highlight: true,
  },
];

const SUPPLEMENTS = [
  {
    title: "Hot Pot",
    subtitle: "Feuertopf",
    schedule: "Mo, Mi, Do, Fr 17:00 – 22:00 · Sa, So & Feiertage 11:30 – 15:30 / 16:30 – 22:00",
    note: "Zum Buffetpreis zusätzlich:",
    prices: [
      ["Kinder 6–12 Jahre", "+3,00 €"],
      ["Ab 13 Jahren", "+4,50 €"],
    ],
  },
  {
    title: "Grill",
    subtitle: "Korean BBQ",
    schedule: "Mo, Mi, Do, Fr 17:00 – 22:00 · Sa, So & Feiertage 11:30 – 15:30 / 16:30 – 22:00",
    note: "Zum Buffetpreis zusätzlich:",
    prices: [
      ["Kinder 6–12 Jahre", "+3,00 €"],
      ["Ab 13 Jahren", "+4,50 €"],
    ],
  },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0b0b0d]/85 backdrop-blur-lg border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 text-white group" data-testid="nav-logo">
          <span className="w-2 h-2 rounded-full bg-[#ff7a1a] shadow-[0_0_12px_#ff7a1a]" />
          <span className="text-xl tracking-tight">
            <span className="font-semibold">Asia</span>{" "}
            <span className="italic font-serif text-[#ff7a1a]">Fusion</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-white/70 hover:text-white transition-colors relative py-1"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button className="hidden md:flex items-center gap-1.5 text-white/70 hover:text-white text-sm px-3 py-1.5 rounded-full border border-white/10" data-testid="lang-switch">
            <Globe size={14} /> DE
          </button>
          <a
            href="tel:+4921628900896"
            data-testid="nav-call-btn"
            className="hidden md:flex items-center gap-2 bg-[#ff7a1a] hover:bg-[#ff8f3d] text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all shadow-[0_8px_30px_-8px_rgba(255,122,26,0.6)]"
          >
            <Phone size={15} /> Jetzt anrufen
          </a>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0b0b0d]/95 backdrop-blur-lg border-t border-white/5 px-6 py-4" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-white/80 hover:text-white text-base border-b border-white/5"
            >
              {l.label}
            </a>
          ))}
          <a href="tel:+4921628900896" className="mt-3 flex items-center gap-2 bg-[#ff7a1a] text-white px-5 py-3 rounded-full text-sm font-medium justify-center">
            <Phone size={15} /> Jetzt anrufen
          </a>
        </div>
      )}
    </header>
  );
};

const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden bg-[#0b0b0d]">
    <div className="absolute inset-0">
      <img src={IMG.hero} alt="Asia Fusion Innenraum" className="w-full h-full object-cover opacity-45" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0b0b0d] via-[#0b0b0d]/70 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0d] via-transparent to-[#0b0b0d]/60" />
    </div>

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-24 w-full">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 mb-8 text-[#ff7a1a] text-xs tracking-[0.3em] font-medium">
          <span className="w-8 h-px bg-[#ff7a1a]" />
          ASIATISCHES BUFFET · VIERSEN
        </div>
        <h1 className="text-white text-6xl md:text-8xl lg:text-9xl leading-[0.95] tracking-tight mb-8">
          <span className="font-semibold">Asia</span>{" "}
          <span className="italic font-serif text-[#ff7a1a]">Fusion</span>
        </h1>
        <p className="text-white/70 text-lg md:text-xl max-w-xl mb-10 leading-relaxed">
          Asiatisches Buffet mit einer großen Vielfalt an köstlichen Gerichten.
        </p>
        <div className="flex flex-wrap gap-4">
          <a
            href="tel:+4921628900896"
            data-testid="hero-reserve-btn"
            className="inline-flex items-center gap-2 bg-[#ff7a1a] hover:bg-[#ff8f3d] text-white px-8 py-4 rounded-full font-medium transition-all shadow-[0_20px_60px_-15px_rgba(255,122,26,0.7)]"
          >
            <Phone size={17} /> Tisch reservieren
          </a>
          <a
            href="#contact"
            data-testid="hero-call-btn"
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white px-8 py-4 rounded-full font-medium transition-all backdrop-blur-sm"
          >
            Jetzt anrufen
          </a>
        </div>
      </div>
    </div>

    <a href="#neu" className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 hover:text-white text-xs tracking-widest flex flex-col items-center gap-2" data-testid="hero-scroll-cue">
      ENTDECKEN
      <span className="w-px h-8 bg-white/30 animate-pulse" />
    </a>
  </section>
);

const NeuSection = () => (
  <section
    id="neu"
    data-testid="neu-section"
    className="relative overflow-hidden bg-gradient-to-b from-[#0b0b0d] via-[#140a06] to-[#0b0b0d] py-28 md:py-36"
  >
    {/* Left plate — Korean BBQ (half visible, sliding) */}
    <div
      className="pointer-events-none absolute top-1/2 -translate-y-1/2 -left-[18%] md:-left-[14%] lg:-left-[10%] w-[55%] md:w-[45%] lg:w-[38%] max-w-[640px] plate-float-left z-10"
      data-testid="neu-plate-bbq"
    >
      <img
        src={IMG.koreanBBQ}
        alt="Koreanisches Barbecue"
        className="w-full h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.7)] plate-spin-slow"
      />
    </div>

    {/* Right plate — Hot Pot (half visible, sliding) */}
    <div
      className="pointer-events-none absolute top-1/2 -translate-y-1/2 -right-[18%] md:-right-[14%] lg:-right-[10%] w-[55%] md:w-[45%] lg:w-[38%] max-w-[640px] plate-float-right z-10"
      data-testid="neu-plate-hotpot"
    >
      <img
        src={IMG.hotPot}
        alt="Hot Pot"
        className="w-full h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.7)] plate-spin-slow-rev"
      />
    </div>

    {/* Glow bg */}
    <div className="absolute inset-0 opacity-40 pointer-events-none">
      <div className="absolute left-1/4 top-1/2 w-96 h-96 bg-[#ff7a1a] rounded-full blur-[140px] -translate-y-1/2" />
      <div className="absolute right-1/4 top-1/2 w-96 h-96 bg-[#c93412] rounded-full blur-[140px] -translate-y-1/2" />
    </div>

    <div className="relative max-w-3xl mx-auto px-6 text-center z-20">
      <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#ff7a1a]/15 border border-[#ff7a1a]/40 text-[#ff9a4a] text-xs tracking-[0.3em] font-medium mb-8" data-testid="neu-badge">
        <Sparkles size={13} /> NEU
      </div>
      <h2 className="text-white text-5xl md:text-7xl leading-[1] tracking-tight mb-6">
        <span className="font-semibold">Neu im</span>{" "}
        <span className="italic font-serif text-[#ff7a1a]">Menü</span>
      </h2>
      <p className="text-2xl md:text-3xl text-white/80 font-light mb-4">
        Koreanisches Barbecue <span className="text-[#ff7a1a]">&</span> Hot Pot
      </p>
      <p className="text-white/60 max-w-xl mx-auto mb-10 leading-relaxed">
        Erleben Sie jetzt bei uns zwei neue Highlights der asiatischen Küche —
        saftig gegrilltes Fleisch am Tisch und heiß dampfende Brühen voller Aromen.
      </p>

      <div className="flex flex-wrap justify-center gap-4">
        <a
          href="#menu"
          data-testid="neu-cta-menu"
          className="inline-flex items-center gap-2 bg-[#ff7a1a] hover:bg-[#ff8f3d] text-white px-7 py-3.5 rounded-full font-medium transition-all shadow-[0_20px_60px_-15px_rgba(255,122,26,0.7)]"
        >
          Menü ansehen <ArrowRight size={16} />
        </a>
        <a
          href="tel:+4921628900896"
          data-testid="neu-cta-call"
          className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/15 text-white px-7 py-3.5 rounded-full font-medium transition-all backdrop-blur-sm"
        >
          <Phone size={15} /> Reservieren
        </a>
      </div>

      {/* Labels for both new dishes */}
      <div className="mt-16 grid grid-cols-2 gap-6 max-w-md mx-auto">
        <div className="text-center">
          <div className="text-[#ff7a1a] text-xs tracking-[0.3em] mb-2">01</div>
          <div className="text-white font-medium">Korean BBQ</div>
          <div className="text-white/40 text-xs mt-1">Grill am Tisch</div>
        </div>
        <div className="text-center">
          <div className="text-[#ff7a1a] text-xs tracking-[0.3em] mb-2">02</div>
          <div className="text-white font-medium">Hot Pot</div>
          <div className="text-white/40 text-xs mt-1">Zwei Brühen</div>
        </div>
      </div>
    </div>
  </section>
);

const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-3 text-[#ff7a1a] text-xs tracking-[0.3em] font-medium mb-6">
    <span className="w-8 h-px bg-[#ff7a1a]" />
    {children}
  </div>
);

const About = () => (
  <section id="about" data-testid="about-section" className="bg-[#0b0b0d] py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-16 items-center">
      <div>
        <SectionLabel>— Über uns</SectionLabel>
        <h2 className="text-white text-5xl md:text-6xl leading-[1.05] tracking-tight mb-8">
          Eine Reise durch <span className="italic font-serif text-[#ff7a1a]">Asiens</span> Küche
        </h2>
        <p className="text-white/60 text-lg leading-relaxed mb-10">
          Asia Fusion ist ein modernes asiatisches Buffet, in dem Sie eine große Auswahl an
          traditionellen und modernen Gerichten genießen können. Frische Zutaten, eine gemütliche
          Atmosphäre und vielfältige Speisen machen unser Restaurant zum perfekten Ort für Mittag-
          und Abendessen.
        </p>
        <div className="grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
          <div>
            <div className="text-4xl text-white font-semibold">100+</div>
            <div className="text-white/50 text-sm mt-1">Gerichte täglich</div>
          </div>
          <div>
            <div className="text-4xl text-white font-semibold">7</div>
            <div className="text-white/50 text-sm mt-1">Asiatische Küchen</div>
          </div>
          <div>
            <div className="text-4xl text-[#ff7a1a] font-semibold">2026</div>
            <div className="text-white/50 text-sm mt-1">Neueröffnung</div>
          </div>
        </div>
      </div>
      <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
        <img src={IMG.gallery2} alt="Interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      </div>
    </div>
  </section>
);

const Gallery = () => {
  const images = [
    { src: IMG.gallery1, label: "Buffet · Copper lamps" },
    { src: IMG.gallery2, label: "Dining Hall · Warm ambience" },
    { src: IMG.gallery3, label: "Frische Auswahl · Buffet" },
    { src: IMG.gallery4, label: "Innenraum · Sternenhimmel" },
  ];
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#0b0b0d] py-28 md:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionLabel>— Galerie</SectionLabel>
        <h2 className="text-white text-5xl md:text-6xl leading-[1.05] tracking-tight mb-4 max-w-2xl">
          Atmosphäre <span className="italic font-serif text-[#ff7a1a]">&amp;</span> Genuss
        </h2>
        <p className="text-white/50 text-lg max-w-xl mb-14">
          Ein Blick in unseren Innenraum — ein Ort, an dem Tradition auf modernes Design trifft.
        </p>
        <div className="grid md:grid-cols-2 gap-4 md:gap-6">
          {images.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-2xl ${i % 3 === 0 ? "aspect-[4/5]" : "aspect-[4/3]"}`}
            >
              <img src={img.src} alt={img.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-5 text-white/90 text-sm">{img.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Hours = () => (
  <section id="hours" data-testid="hours-section" className="bg-[#0b0b0d] py-28 md:py-36 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-16">
      <div>
        <SectionLabel>— Öffnungszeiten</SectionLabel>
        <h2 className="text-white text-5xl md:text-6xl leading-[1.05] tracking-tight mb-6">
          Wir freuen uns auf <span className="italic font-serif text-[#ff7a1a]">Sie</span>
        </h2>
        <div className="inline-flex items-center gap-2 text-[#ff7a1a] text-sm">
          <Clock size={15} /> Donnerstag · Heute
        </div>
      </div>
      <div className="divide-y divide-white/10 border-t border-b border-white/10">
        {HOURS.map((h) => (
          <div
            key={h.day}
            data-testid={`hours-row-${h.day.toLowerCase()}`}
            className={`flex items-center justify-between py-5 ${h.today ? "bg-[#ff7a1a]/5 px-4 -mx-4 rounded-lg" : ""}`}
          >
            <div className="flex items-center gap-3">
              <span className={`text-lg ${h.today ? "text-[#ff7a1a]" : "text-white"}`}>{h.day}</span>
              {h.today && <span className="text-xs text-[#ff7a1a] tracking-widest">HEUTE</span>}
            </div>
            <span className={`text-sm ${h.closed ? "text-white/40 italic" : "text-white/70"}`}>{h.time}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const MenuSection = () => (
  <section id="menu" data-testid="menu-section" className="bg-[#0b0b0d] py-28 md:py-36 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <SectionLabel>— Speisekarte</SectionLabel>
      <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
        <h2 className="text-white text-5xl md:text-7xl leading-[1.05] tracking-tight max-w-2xl">
          All You <span className="italic font-serif text-[#ff7a1a]">Can</span> Taste
        </h2>
        <p className="text-white/50 text-lg max-w-md">
          Genießen Sie unser vielfältiges Buffet oder wählen Sie aus unseren à-la-carte-Gerichten —
          frisch zubereitet, jeden Tag.
        </p>
      </div>

      {/* Buffet cards */}
      <div className="grid md:grid-cols-3 gap-5 mb-12">
        {BUFFETS.map((b, idx) => (
          <div
            key={idx}
            data-testid={`buffet-card-${idx}`}
            className={`rounded-3xl p-8 border transition-all ${
              b.highlight
                ? "bg-gradient-to-br from-[#ff7a1a]/15 to-[#c93412]/10 border-[#ff7a1a]/30"
                : "bg-white/[0.03] border-white/10 hover:border-white/20"
            }`}
          >
            <h3 className="text-white text-2xl mb-1 font-semibold">{b.title}</h3>
            <div className="text-[#ff7a1a] text-sm mb-6">{b.time}</div>

            {b.twoColumns ? (
              <div className="grid grid-cols-2 gap-x-4 gap-y-0 mb-6">
                {b.columns.map((col, idx) => (
                  <div key={col.label} className={idx === 0 ? "pr-2 border-r border-white/10" : "pl-2"}>
                    <div className="text-[#ff9a4a] text-[10px] tracking-[0.2em] font-semibold uppercase mb-3">
                      {col.label}
                    </div>
                    <div className="divide-y divide-white/10">
                      {col.prices.map((p) => (
                        <div key={p[0]} className="flex flex-col py-2">
                          <span className="text-white/60 text-[11px] leading-tight">{p[0]}</span>
                          <span className="text-white font-semibold text-sm mt-0.5">{p[1]}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="divide-y divide-white/10 mb-6">
                {b.prices.map((p) => (
                  <div key={p[0]} className="flex justify-between py-2.5 text-sm">
                    <span className="text-white/70">{p[0]}</span>
                    <span className="text-white font-medium">{p[1]}</span>
                  </div>
                ))}
              </div>
            )}

            <p className="text-white/50 text-xs leading-relaxed">{b.note}</p>
          </div>
        ))}
      </div>

      {/* Hot Pot & Korean BBQ supplements */}
      <div className="mb-20">
        <div className="flex items-baseline gap-3 mb-6">
          <span className="text-[#ff7a1a] text-xs tracking-[0.3em]">— ZUSCHLÄGE</span>
        </div>
        <h3 className="text-white text-3xl md:text-4xl mb-2">
          Korean BBQ <span className="italic font-serif text-[#ff7a1a]">&</span> Hot Pot
        </h3>
        <p className="text-white/50 text-sm mb-8">Zum Buffetpreis zusätzlich.</p>
        <div className="grid md:grid-cols-2 gap-5">
          {SUPPLEMENTS.map((s) => (
            <div
              key={s.title}
              data-testid={`supplement-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-3xl p-8 border border-[#ff7a1a]/25 bg-gradient-to-br from-[#ff7a1a]/10 to-transparent"
            >
              <div className="flex items-baseline justify-between mb-3">
                <h4 className="text-white text-2xl font-semibold">
                  {s.title}{" "}
                  <span className="italic font-serif text-[#ff7a1a] text-xl font-normal">({s.subtitle})</span>
                </h4>
              </div>
              <div className="text-[#ff9a4a] text-xs mb-6 leading-relaxed">{s.schedule}</div>
              <p className="text-white/60 text-xs mb-4">{s.note}</p>
              <div className="divide-y divide-white/10">
                {s.prices.map((p) => (
                  <div key={p[0]} className="flex justify-between py-3">
                    <span className="text-white/80 text-sm">{p[0]}</span>
                    <span className="text-[#ff7a1a] font-semibold">{p[1]}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* À la carte */}
      <h3 className="text-white text-3xl md:text-4xl mb-2">
        Hauptgerichte · <span className="italic font-serif text-[#ff7a1a]">À la carte</span>
      </h3>
      <div className="grid md:grid-cols-2 gap-x-12 gap-y-1 mt-8 mb-6">
        {ALA_CARTE.map(([num, name, price]) => (
          <div key={num} data-testid={`ala-carte-${num}`} className="flex items-baseline gap-4 py-3.5 border-b border-white/5">
            <span className="text-[#ff7a1a] text-xs font-mono w-6">{num}</span>
            <span className="text-white/85 flex-1">{name}</span>
            <span className="text-white font-medium whitespace-nowrap">{price}</span>
          </div>
        ))}
      </div>
      <p className="text-white/50 text-sm mb-20">
        Jedes Gericht enthält ein Getränk (Cola, Cola Zero, Fanta, Sprite, Apfelschorle, Wasser,
        Kaffee, Tee).
      </p>

      {/* Take Away */}
      <h3 className="text-white text-3xl md:text-4xl mb-8">
        <span className="text-[#ff7a1a]">▸</span> Asia Box <span className="italic font-serif text-[#ff7a1a]">To Go</span>
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {TAKEAWAY.map((t) => (
          <div key={t.name} data-testid={`takeaway-${t.name.toLowerCase().replace(/\s+/g, "-")}`} className="rounded-2xl bg-white/[0.03] border border-white/10 p-6 hover:border-[#ff7a1a]/40 transition-all">
            <div className="text-white text-lg font-semibold">{t.name}</div>
            <div className="text-[#ff7a1a] text-2xl font-semibold mt-1">{t.price}</div>
            {t.desc && <div className="text-white/50 text-sm mt-3 leading-relaxed">{t.desc}</div>}
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap gap-4 text-sm">
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#ff7a1a]/10 border border-[#ff7a1a]/30 text-[#ff9a4a]">
          ★ Studenten-Rabatt auf Anfrage
        </div>
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/5 border border-white/10 text-white/80">
          🎂 Geburtstagsgäste ab 18 Jahren erhalten eine Flasche Sekt gratis
        </div>
      </div>
    </div>
  </section>
);

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-[#0b0b0d] py-28 md:py-36 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-16">
      <div>
        <SectionLabel>— Kontakt</SectionLabel>
        <h2 className="text-white text-5xl md:text-6xl leading-[1.05] tracking-tight mb-10">
          Besuchen Sie <span className="italic font-serif text-[#ff7a1a]">uns</span>
        </h2>
        <div className="flex flex-wrap gap-4">
          <a href="tel:+4921628900896" data-testid="contact-call-btn" className="inline-flex items-center gap-2 bg-[#ff7a1a] hover:bg-[#ff8f3d] text-white px-7 py-3.5 rounded-full font-medium transition-all">
            <Phone size={16} /> Jetzt anrufen
          </a>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Rathausmarkt%2050%2C%2041747%20Viersen"
            target="_blank" rel="noopener noreferrer"
            data-testid="contact-route-btn"
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white px-7 py-3.5 rounded-full font-medium transition-all"
          >
            <MapPin size={16} /> Route anzeigen
          </a>
        </div>
      </div>
      <div className="space-y-6">
        <div className="rounded-2xl border border-white/10 p-6">
          <div className="text-white/40 text-xs tracking-widest mb-2">ADRESSE</div>
          <div className="text-white text-lg">Rathausmarkt 50, 41747 Viersen</div>
        </div>
        <div className="rounded-2xl border border-white/10 p-6">
          <div className="text-white/40 text-xs tracking-widest mb-2">STANDORT</div>
          <div className="text-white text-lg">Rathausmarkt Galerie</div>
        </div>
        <a href="tel:+4921628900896" className="block rounded-2xl border border-white/10 p-6 hover:border-[#ff7a1a]/40 transition-colors">
          <div className="text-white/40 text-xs tracking-widest mb-2">TELEFON</div>
          <div className="text-white text-lg flex items-center gap-2">
            <Phone size={16} className="text-[#ff7a1a]" /> 02162 8900896
          </div>
        </a>
      </div>
    </div>
  </section>
);

const Parking = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
  <section id="parking" data-testid="parking-section" className="bg-[#0b0b0d] py-28 md:py-36 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <SectionLabel>— Standort &amp; Parken</SectionLabel>
      <h2 className="text-white text-5xl md:text-6xl leading-[1.05] tracking-tight mb-14">
        So finden <span className="italic font-serif text-[#ff7a1a]">Sie uns</span>
      </h2>
      <div className="grid lg:grid-cols-2 gap-8">
        <button
          type="button"
          onClick={() => setOpen(true)}
          data-testid="parking-map-open"
          className="group relative rounded-3xl overflow-hidden aspect-[4/3] cursor-zoom-in text-left focus:outline-none focus:ring-2 focus:ring-[#ff7a1a] focus:ring-offset-2 focus:ring-offset-[#0b0b0d]"
          aria-label="Karte vergrößern"
        >
          <img src={IMG.parking} alt="Parkmöglichkeiten und Standort" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
          <div className="absolute top-4 right-4 flex items-center gap-2 bg-black/50 backdrop-blur-md border border-white/20 text-white text-xs px-3 py-2 rounded-full opacity-90 group-hover:opacity-100">
            <ZoomIn size={14} /> Vergrößern
          </div>
          <div className="absolute bottom-5 left-5 text-white text-sm">Standortkarte · Parkplätze P</div>
        </button>
        <div>
          <div className="text-[#ff7a1a] text-xs tracking-[0.3em] mb-4">— PARKMÖGLICHKEITEN</div>
          <h3 className="text-white text-3xl md:text-4xl mb-4">Bequem parken in der Nähe</h3>
          <p className="text-white/60 mb-8">
            Zwei öffentliche Parkplätze befinden sich nur wenige Schritte vom Restaurant entfernt.
          </p>
          <div className="space-y-4">
            {[
              { name: "Heckenweg", addr: "Heckenweg, 41747 Viersen", url: "https://maps.app.goo.gl/Bu2MMXNk2pvAjLhR8" },
              { name: "Diergardtstraße", addr: "Diergardtstraße, 41747 Viersen", url: "https://maps.app.goo.gl/ba7AYFQX6UAFn5dB6" },
            ].map((p) => (
              <a
                key={p.name}
                href={p.url}
                target="_blank" rel="noopener noreferrer"
                data-testid={`parking-${p.name.toLowerCase()}`}
                className="flex items-center justify-between gap-4 rounded-2xl bg-white/[0.03] border border-white/10 p-5 hover:border-[#ff7a1a]/40 transition-colors group"
              >
                <div>
                  <div className="text-white font-medium">{p.name}</div>
                  <div className="text-white/50 text-sm mt-0.5">{p.addr}</div>
                </div>
                <ArrowRight size={18} className="text-[#ff7a1a] group-hover:translate-x-1 transition-transform" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>

    {open && (
      <div
        data-testid="parking-map-lightbox"
        role="dialog"
        aria-modal="true"
        onClick={() => setOpen(false)}
        className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 md:p-10 animate-[fadeIn_0.2s_ease-out]"
      >
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setOpen(false); }}
          data-testid="parking-map-close"
          aria-label="Schließen"
          className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white flex items-center justify-center backdrop-blur-md"
        >
          <X size={20} />
        </button>
        <img
          src={IMG.parking}
          alt="Standortkarte vergrößert"
          onClick={(e) => e.stopPropagation()}
          className="max-h-full max-w-full w-auto h-auto object-contain rounded-xl shadow-[0_30px_80px_rgba(0,0,0,0.7)]"
        />
      </div>
    )}
  </section>
  );
};

const Footer = () => (
  <footer className="bg-[#0b0b0d] border-t border-white/5 py-12" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-wrap items-center justify-between gap-6">
      <div className="flex items-center gap-2 text-white">
        <span className="w-2 h-2 rounded-full bg-[#ff7a1a]" />
        <span className="text-lg">
          <span className="font-semibold">Asia</span>{" "}
          <span className="italic font-serif text-[#ff7a1a]">Fusion</span>
        </span>
      </div>
      <div className="text-white/40 text-sm">© 2026 Asia Fusion · Rathausmarkt 50, 41747 Viersen</div>
      <a href="tel:+4921628900896" className="text-white/70 hover:text-white text-sm inline-flex items-center gap-2">
        <Phone size={14} /> 02162 8900896
      </a>
    </div>
  </footer>
);

function App() {
  return (
    <div className="App bg-[#0b0b0d] min-h-screen">
      <Navbar />
      <Hero />
      <NeuSection />
      <About />
      <Gallery />
      <Hours />
      <MenuSection />
      <Contact />
      <Parking />
      <Footer />
    </div>
  );
}

export default App;
